import { useTranslation } from 'react-i18next';
import { Modal } from '../../UI';
import { Button } from '../../UI/base/Button';
import modalStyles from '../../UI/Modal.module.css';
import styles from './RecalculateWeekModal.module.css';

interface RecalculateWeekModalProps {
  weekNumber: number;
  isTriggering: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export const RecalculateWeekModal = ({
  weekNumber,
  isTriggering,
  onConfirm,
  onClose
}: RecalculateWeekModalProps) => {
  const { t } = useTranslation();

  // Modal's Enter shortcut expects a void handler; Button awaits the promise itself.
  const handleConfirmKey = (): void => {
    void onConfirm();
  };

  return (
    <Modal
      title={t('gantt-recalculate-week-title')}
      onClose={onClose}
      onConfirm={handleConfirmKey}
      width={480}
      footer={
        <div className={modalStyles.footerRow}>
          <Button type="secondary" onClick={onClose} disabled={isTriggering}>
            {t('save-modal-cancel')}
          </Button>
          <Button type="primary" onClick={onConfirm}>
            {t('gantt-recalculate-week-confirm')}
          </Button>
        </div>
      }
    >
      <div className={styles.body}>
        <p className={styles.message}>
          {t('gantt-recalculate-week-message', { week: weekNumber })}
        </p>
      </div>
    </Modal>
  );
};
